import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { applyDocumentSeo } from '../seo/applyDocumentSeo.js'
import { getSeoForPath } from '../seo/routeMeta.js'

/** Syncs title, description, canonical, Open Graph, and Twitter Card meta to the active route. */
export default function SeoManager() {
  const { pathname } = useLocation()

  useEffect(() => {
    applyDocumentSeo(getSeoForPath(pathname))
  }, [pathname])

  return null
}
